var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "264px",
    height: "227px",
    viewBox: "0 0 264 227",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.31785067%",
    y1: "-10.7355126%",
    x2: "39.0037351%",
    y2: "37.9643388%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "99.42%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.554855,71.1103797 L194,186.964177 C194,190.925696 190.74687,194 186.77013,194 L73.231943,194 C69.2552037,194 66,190.760633 66,186.964177 L66,38.0151899 C66,34.0536709 69.2552037,31 73.231943,31 L155.493221,31 L192.554855,71.1103797 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-30.1%",
    y: "-16.9%",
    width: "160.2%",
    height: "147.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 11,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.27 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3---L---Landing-Page-(Step-8)",
    transform: "translate(-583.000000, -241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(371.000000, 85.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 22,
    transform: "translate(212.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.5,222 C192.938776,222 243,172.230698 243,111.103256 C242.793135,49.7693023 192.938776,0 131.5,0 C69.8543599,0 20,49.7693023 20,110.896744 C20,172.230698 69.8543599,222 131.5,222 Z",
    id: "Path",
    fill: "#D1EEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.001035,95 C118.406679,95 131,82.4769688 131,67 C131,51.5230312 118.406679,39 103.001035,39 C87.5933213,39 75,51.5230312 75,67 C75,82.4769688 87.5933213,95 103.001035,95 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,72 C250.195732,72 254,68.1853659 254,63.5 C254,58.7939024 250.195732,55 245.5,55 C240.806341,55 237,58.7939024 237,63.5 C237,68.1853659 240.806341,72 245.5,72 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5,39 C261.53875,39 264,36.525 264,33.5 C264,30.4553571 261.53875,28 258.5,28 C255.463214,28 253,30.4553571 253,33.5 C253,36.525 255.463214,39 258.5,39 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,185 C16.2992308,185 21,180.295192 21,174.5 C21,168.684615 16.2992308,164 10.5,164 C4.70076923,164 0,168.684615 0,174.5 C0,180.295192 4.70076923,185 10.5,185 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.122,168 L117.878,168 C117.39,168 117,167.77 117,167.5 C117,167.22 117.39,167 117.878,167 L120.122,167 C120.61,167 121,167.22 121,167.5 C121,167.81 120.61,168 120.122,168 Z",
    id: "Path",
    fill: "#CED7E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.51875,168 L85.4791667,168 C84.6583333,168 84,167.77 84,167.5 C84,167.22 84.6583333,167 85.4791667,167 L107.51875,167 C108.341667,167 109,167.22 109,167.5 C109,167.81 108.341667,168 107.51875,168 Z",
    id: "Path",
    fill: "#D5DDEA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6945,56 L86.3055,56 C85.0647143,56 84,55.06 84,54 C84,52.92 85.0647143,52 86.3055,52 L139.6945,52 C140.935286,52 142,52.92 142,54 C142,55.06 140.935286,56 139.6945,56 Z",
    id: "Path",
    fill: "#D5DDEA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.872917,69 L86.3041667,69 C85.0625,69 84,68.06 84,67 C84,65.92 85.0625,65 86.3041667,65 L106.69375,65 C107.935417,65 109,65.92 109,67 C109,68.06 107.935417,69 106.872917,69 Z",
    id: "Path",
    fill: "#D5DDEA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,31 L156,63.718 C156,68.31 160.05537,72 164.66279,72 L193,70.975",
    id: "Path",
    fill: "#11763D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.808764,89.2389296 C117.105636,85.8843581 123.350921,84 130.004463,84 C148.200162,84 163,98.4950621 163,116.510354 C163,134.504938 148.200162,149 130.004463,149 C111.808764,149 97.0089256,134.504938 97.0089256,116.510354 C96.7367543,105.079962 102.711961,95.1404906 111.808764,89.2389296 Z",
    id: "Path",
    fill: "#18A957"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Checkmark/Default",
    transform: "translate(114.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "24pt-Bounding-Box",
    opacity: 0,
    fillRule: "nonzero",
    points: "0 0 34 0 34 34 0 34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9683333,25.5 L13.9683333,25.5 C13.5756829,25.4987369 13.2011687,25.3345659 12.9341667,25.0466667 L6.04916668,17.7225 L6.04916662,17.7224999 C5.51322037,17.1513453 5.54176195,16.2538699 6.11291676,15.7179166 C6.68407143,15.1819704 7.58154676,15.2105119 8.1175001,15.7816667 C8.1175001,15.7816667 8.11750012,15.7816668 8.11750012,15.7816668 L13.9541668,22.0008334 L25.8683335,8.9675001 L25.8683333,8.96750027 C26.3582308,8.35745527 27.2499106,8.26005519 27.8599541,8.74995269 C28.4699991,9.23985019 28.5673992,10.1315299 28.0775017,10.7415735 C28.0424858,10.7851771 28.0049188,10.8266691 27.9649977,10.8658316 L15.0166644,25.0324983 L15.0166645,25.0324982 C14.752153,25.3256391 14.3773058,25.4950895 13.9824978,25.5 L13.9683333,25.5 Z",
    id: "Fill",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e85e3da48956349d0f6445420b4336db.svg";
export { ForwardRef as ReactComponent };